import React, { memo } from 'react';
const SuccessFilled = memo(props => {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: ['bcz-icon', props.className].filter(Boolean).join(' '),
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9697 3.96967L14.0304 5.03033L6.50006 12.5607L2.46973 8.53033L3.53039 7.46967L6.50006 10.4393L12.9697 3.96967Z"
  }));
});
export default SuccessFilled;